export default __webpack_public_path__ + "static/media/parking-active.e1738720.svg";